import crypto from 'crypto-js';  

 
const  encrypt=(data)=> { 

    const encrypted =   crypto.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_PUBLIC_S_KEY).toString();
    return JSON.stringify({"data":encrypted});
}


const decrypt=(encryptedData) =>{
    const decrypted = crypto.AES.decrypt(encryptedData.data, process.env.REACT_APP_PUBLIC_S_KEY).toString(crypto.enc.Utf8);
    return JSON.parse(decrypted);
}

export { encrypt, decrypt };
